import React from "react";
import "./App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider, useAuth } from "./context/AuthContext";
import Layout from "./components/Layout";
import { Toaster } from "./components/ui/sonner";
import Login from "./pages/Login";
import Home from "./pages/Home";
import Deposit from "./pages/Deposit";
import Retrieve from "./pages/Retrieve";
import Lockers from "./pages/Lockers";
import MyLog from "./pages/MyLog";
import Timeline from "./pages/Timeline";
import Admin from "./pages/Admin";

// Protected Route wrapper
const ProtectedRoute = ({ children }) => {
  const { currentUser } = useAuth();
  
  if (!currentUser) {
    return <Navigate to="/login" replace />;
  }
  
  return children;
};

// Main App Routes
const AppRoutes = () => {
  const { currentUser } = useAuth();
  
  return (
    <Routes>
      <Route 
        path="/login" 
        element={currentUser ? <Navigate to="/" replace /> : <Login />} 
      />
      <Route
        path="/*"
        element={
          <ProtectedRoute>
            <Layout>
              <Routes>
                <Route path="/" element={<Home />} />
                <Route path="/deposit" element={<Deposit />} />
                <Route path="/retrieve" element={<Retrieve />} />
                <Route path="/lockers" element={<Lockers />} />
                <Route path="/mylog" element={<MyLog />} />
                <Route path="/admin" element={<Admin />} />
                <Route path="/timeline" element={<Timeline />} />
              </Routes>
            </Layout>
          </ProtectedRoute>
        }
      />
    </Routes>
  );
};

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <AppRoutes />
        <Toaster />
      </BrowserRouter>
    </AuthProvider>
  );
}

export default App;
